import { forwardRef, IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react'
import { PopUpMessageContext } from '@hb/react'
import { useContext, useEffect } from 'react'
import { useCopied } from '../CopyTooltip'

export const buttonProps: Partial<IconButtonProps> = {
  bg: 'blackAlpha.50',
  _hover: { bg: 'blue.200' },
}
export const DisplayButtonBase = forwardRef((props: IconButtonProps, ref) => (
  <IconButton ref={ref} height={[6, 8]} flex={1} {...buttonProps} {...props} />
))

export const DisplayButton = (props: IconButtonProps & { text: string }) => {
  const { text } = props
  const { copied, onClick } = useCopied(props.text ?? '')
  const { showSuccess } = useContext(PopUpMessageContext)
  useEffect(() => {
    if (copied) {
      showSuccess(`Copied ${text}`)
    }
  }, [text, copied, showSuccess])
  return (
    <Tooltip placement="top" label={props.text ?? ''}>
      <DisplayButtonBase onClick={onClick} {...props} />
    </Tooltip>
  )
}
